'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import { Map as ImmutableMap, fromJS } from 'immutable';
import Actions from 'AdsUI/lib/Actions';
const initialState = ImmutableMap(); // Note: This basically duplicates the existing stuff in the
// AdWordsAdGroup reducer. We'll have to figure out the right
// structure and prevent duplciation; this setup is a bit cleaner
// but the naming isn't ideal.

export default ((state = initialState, action) => {
  const {
    type,
    payload = {}
  } = action;

  switch (type) {
    case Actions.ADWORDS_CAMPAIGN_GET_ADGROUPS_SUCCEEDED:
      {
        const campaignAdGroupsPath = ['campaignAdGroups', payload.campaignId, 'adGroups'];
        state = state.setIn(campaignAdGroupsPath, fromJS(payload.data));
        break;
      }

    case Actions.ADWORDS_ADGROUP_UPDATE_START:
      {
        const {
          campaignId,
          adGroupId
        } = payload,
              opts = _objectWithoutPropertiesLoose(payload, ["campaignId", "adGroupId"]);

        if (!campaignId) break;
        const campaignPath = ['campaignAdGroups', campaignId, 'adGroups'];
        const adGroupLocation = state.getIn(campaignPath).findIndex(e => adGroupId === e.id);
        state = state.mergeIn([...campaignPath, adGroupLocation], opts);
        break;
      }

    default:
      return state;
  }

  return state;
});